/**
 * Asset URL resolver — fp-header, fp-promo-image ve diğer asset render
 * eden component'lerin ortak helper'ı.
 *
 * PWA browser tarafında çalıştığı için device JWT'i <img> tag'ine eklemez.
 * Asset endpoint'i `api(-staging).fiyatpanom.com/api/public/assets/{id}/raw`
 * — auth yok, throttle korumalı, UUIDv7 tahmin edilemez (yeterli güvenlik MVP'de).
 * NOT: route `prefix('public')` (v1 ALTINDA DEĞİL) → yol /api/public/... ; v1'li yol 404.
 *
 * Faz 2: signed URL + expires_at parametresi; Gateway initial_state.assets
 * map'inde URL'leri inject etsin, helper bu map'ten lookup yapsın.
 *
 * VITE_API_URL build-time env (vite.config matrix variant ile staging/prod ayrı).
 * Set edilmemişse window.location host'unu pattern ile çevirir (screen-staging →
 * api-staging).
 */
export function assetUrl(assetId: string | null | undefined): string | null {
    if (!assetId) return null;
    return `${apiBase()}/api/public/assets/${encodeURIComponent(assetId)}/raw`;
}

export function apiBase(): string {
    const envBase = import.meta.env.VITE_API_URL as string | undefined;
    if (envBase) return envBase.replace(/\/$/, '');

    // Fallback: host pattern (screen-staging.x → api-staging.x, screen.x → api.x)
    const host = window.location.host;
    const apiHost = host
        .replace(/^screen-staging\./, 'api-staging.')
        .replace(/^screen\./, 'api.');
    return `${window.location.protocol}//${apiHost}`;
}
